import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:'',
    inforList: [{
        inforTitle: '123',
        inforText: '342'
      },
      {
        inforTitle: '123',
        inforText: '348'
      },

    ]

  },
  mutations: {
    getInforList(state, inforList) {
      return state.inforList = inforList
    },
    setToken(state, token) {
      state.token = 'bearer'+ token
     
    },

  },
  actions: {

  },
  modules: {

  }
})